module.exports = __webpack_public_path__ + "static/CocoaPowder-bb4002c515faa224ac8155b849660d57.webp";